/* globals angular */
import contractorGalleryModel from './models/contractor_gallery_model'

window.bz_contractor_module = angular
  .module('bzContractorModule', [])
  .service('contractorGalleryModel', contractorGalleryModel)
